import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { GlobalConstants } from 'src/app/pages/common/global-variables';

@Injectable()
export class SpecialProjectCheck {
  subProjectLinks = this.globalConstants.data.subProjectLinks;
    constructor(
      @Inject(DOCUMENT) private document: any,
      private globalConstants: GlobalConstants,
    ) {

    }
    checkProject(){
      let pathname = this.document.location.pathname.split('/',3);
      if(this.subProjectLinks && this.subProjectLinks.includes(pathname[2])){
        return {
          type: 'special',
          code: pathname[2]
        }
      }
      else{
        return {
          type: 'default'
        }
      }
    }
}
